import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles36 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial36/tutorial36.zip?ref_type=heads&inline=false', download: 'tutorial36.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtySix= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How To Change Fonts of Selected Text Across Multiple Lines In Text Box with Print Preview</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/-9SRtDg8vmg/maxresdefault.jpg"
                            alt="Tutorial 36"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this PyQt6 tutorial, you’ll learn how to change the fonts of selected text across multiple lines inside a text box and implement a Print Preview feature. This step-by-step guide walks you through creating an interactive and professional-grade text editor where users can style their text and preview it before printing.

                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Changing fonts of selected multi-line text in a QTextEdit</li>
                            <li>Integrating a Print Preview feature using QPrinter</li>

                            <li>Designing the interface with Qt Designer</li>

                            <li>Enhancing user experience with rich text formatting and preview capabilities</li>
                            <li>Common pitfalls (including using self correctly to retain font settings)</li>
                        </ul>

                        Whether you're a beginner or experienced developer, this tutorial will help you bring polished text-editing and print preview functionality to your PyQt6 applications.
                        <br /><br />
                        #PyQt6 #QtDesigner #Python3 #TextFormatting #PrintPreview #QTextEdit #FontCustomization #GUI #PythonDevelopment

                    </p>

                    <button className="seemore">
                        <DownloadFiles36 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtySix;
